import { redtypes } from '../../types/redTypes';

export const userReducer = (state, action) => {
    switch (action.type) {
        case redtypes.loadUsuarios:
            return {
                ...state,
                usuarios: [...action.payload],
            };
        case redtypes.loadClientes:
            return {
                ...state,
                clientes: [...action.payload],
            };
        case redtypes.loadAgentes:
            return {
                ...state,
                agentes: [...action.payload],
            };
        case redtypes.contracargos:
            return {
                ...state,
               chargebacks: [...action.payload],
            };

        case redtypes.card1:
            return {
                ...state,
                dsTras: action.payload,
            };
        case redtypes.card2:
            return {
                ...state,
                dsInstall: action.payload,
            };
        case redtypes.card3:
            return {
                ...state,
                dsTks: action.payload,
            };
        case redtypes.resumen:
            return {
                ...state,
                resumen: action.payload,
            };
        case redtypes.trafico:
            return {
                ...state,
                trafico: action.payload,
            };
        case redtypes.resfin:
            return {
                ...state,
                resFin: action.payload,
            };
        case redtypes.basicdash:
            return {
                ...state,
                dashboard: action.payload,
            };
        case redtypes.idEmploye:
            return {
                ...state,
                idemploye: action.payload,
            };
        case redtypes.perm:
            return {
                ...state,
                permisos: action.payload,
            };
        case redtypes.cerrarSesion:
            return {
                usuarios: [],
                page: 'list',
                clientes: [],
                agentes: [],

                dsTras: { stats: 0, trend: 0, total: 0, data: [] },
                dsInstall: { stats: 0, trend: 0, total: 0, data: [] },
                dsTks: { stats: 0, trend: 0, total: 0, data: [] },
                trafico: { days: [], down: [], up: [] },
                dashboard: { clientes: 0, cliOnline: 0, pagos: [], promisePays: [], olts: [] },
                resFin: [],
                resumen: {},
                ds: {},
                idemploye: null,
                permisos: 0,
            };

        default:
            return state;
    }
};
